import { YStack, XStack, Text, styled } from 'tamagui'
import { Card } from '../ui'
import { copy } from '../../content/copy'

const Section = styled(YStack, {
  name: 'CaseStudySection',
  paddingHorizontal: '$6',
  paddingVertical: '$16',
  backgroundColor: '$backgroundSecondary',

  '$md': {
    paddingHorizontal: '$4',
    paddingVertical: '$10',
  },
})

const Container = styled(YStack, {
  name: 'Container',
  maxWidth: 1200,
  marginHorizontal: 'auto',
  width: '100%',
  gap: '$10',
})

const Header = styled(YStack, {
  name: 'Header',
  gap: '$3',
  marginBottom: '$4',
})

const HeaderRow = styled(XStack, {
  name: 'HeaderRow',
  alignItems: 'flex-start',
  gap: '$4',
})

const SectionNumber = styled(Text, {
  name: 'SectionNumber',
  fontFamily: '$accent',
  fontSize: '$2',
  color: '$textMuted',
  letterSpacing: 2,
})

const SectionTitle = styled(Text, {
  name: 'SectionTitle',
  fontFamily: '$accent',
  fontSize: '$3',
  color: '$orangePrimary',
  letterSpacing: 2,
  textTransform: 'uppercase',
})

const MainHeader = styled(Text, {
  name: 'MainHeader',
  // @ts-ignore
  render: 'h2',
  fontFamily: '$heading',
  fontSize: '$8',
  fontWeight: '600',
  color: '$textPrimary',
  marginTop: '$4',

  '$md': {
    fontSize: '$7',
  },
})

const StudiesGrid = styled(YStack, {
  name: 'StudiesGrid',
  gap: '$6',

  '$gtMd': {
    flexDirection: 'row',
    gap: '$8',
  },
})

const StudyCard = styled(Card, {
  name: 'StudyCard',
  gap: '$4',
  borderTopWidth: 3,
  borderTopColor: '$orangePrimary',

  '$gtMd': {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    minWidth: 0,
  },
})

const CategoryTag = styled(Text, {
  name: 'CategoryTag',
  fontFamily: '$accent',
  fontSize: '$1',
  color: '$orangePrimary',
  letterSpacing: 2,
  textTransform: 'uppercase',
})

const StudyName = styled(Text, {
  name: 'StudyName',
  // @ts-ignore
  render: 'h3',
  fontFamily: '$heading',
  fontSize: '$7',
  fontWeight: '700',
  color: '$textPrimary',

  '$md': {
    fontSize: '$6',
  },
})

const StudyHeadline = styled(Text, {
  name: 'StudyHeadline',
  fontFamily: '$body',
  fontSize: '$5',
  fontWeight: '500',
  color: '$textPrimary',
  lineHeight: '$6',
})

const StudyDescription = styled(Text, {
  name: 'StudyDescription',
  fontFamily: '$body',
  fontSize: '$4',
  lineHeight: '$5',
  color: '$textSecondary',
})

const ResultsList = styled(YStack, {
  name: 'ResultsList',
  gap: '$3',
  marginTop: '$2',
})

const ResultItem = styled(XStack, {
  name: 'ResultItem',
  gap: '$3',
  alignItems: 'flex-start',
})

const CheckIcon = styled(Text, {
  name: 'CheckIcon',
  fontFamily: '$body',
  fontSize: '$4',
  color: '#60A5FA',
  fontWeight: '600',
  lineHeight: '$5',
})

const ResultText = styled(Text, {
  name: 'ResultText',
  fontFamily: '$body',
  fontSize: '$4',
  color: '$textPrimary',
  lineHeight: '$5',
  flexGrow: 1,
  flexShrink: 1,
  minWidth: 0,
})

const StackTag = styled(Text, {
  name: 'StackTag',
  fontFamily: '$mono',
  fontSize: '$2',
  color: '$textMuted',
  marginTop: '$2',
  paddingTop: '$4',
  borderTopWidth: 1,
  borderTopColor: '$border',
})

export function CaseStudySection() {
  const { sectionNumber, sectionTitle, header, studies } = copy.caseStudies

  return (
    <Section id="work">
      <Container>
        <Header>
          <HeaderRow>
            <SectionNumber>{sectionNumber}</SectionNumber>
            <SectionTitle>{sectionTitle}</SectionTitle>
          </HeaderRow>
          <MainHeader>{header}</MainHeader>
        </Header>

        <StudiesGrid>
          {studies.map((study) => (
            <StudyCard key={study.name} variant="elevated" size="lg">
              <CategoryTag>{study.category}</CategoryTag>
              <StudyName>{study.name}</StudyName>
              <StudyHeadline>{study.headline}</StudyHeadline>
              <StudyDescription>{study.description}</StudyDescription>

              <ResultsList>
                {study.results.map((result, i) => (
                  <ResultItem key={i}>
                    <CheckIcon>{'✓'}</CheckIcon>
                    <ResultText>{result}</ResultText>
                  </ResultItem>
                ))}
              </ResultsList>

              <StackTag>{study.stack}</StackTag>
            </StudyCard>
          ))}
        </StudiesGrid>
      </Container>
    </Section>
  )
}
